import { useState } from "react";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { AdminDashboard } from "./components/AdminDashboard";
import { AdminUsersPage } from "./components/AdminUsersPage";
import { AuthPage } from "./components/AuthPage";
import { ChatWindow } from "./components/ChatWindow";

function AuthorizedApp() {
  const { user } = useAuth();
  const isSuperadmin = user?.role === "superadmin";
  const canManageUsers = isSuperadmin;
  const [view, setView] = useState<"dashboard" | "admin" | "chat">(
    isSuperadmin ? "dashboard" : "chat"
  );

  if (view === "dashboard" && isSuperadmin) {
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
        <div style={{ padding: "8px", background: "#2c3e50", display: "flex", gap: "8px", justifyContent: "center" }}>
          <button
            onClick={() => setView("dashboard")}
            style={{
              padding: "8px 16px",
              background: "#3498db",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            📈 Dashboard
          </button>
          <button
            onClick={() => setView("admin")}
            style={{
              padding: "8px 16px",
              background: "#95a5a6",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            👥 User Management
          </button>
          <button
            onClick={() => setView("chat")}
            style={{
              padding: "8px 16px",
              background: "#95a5a6",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            💬 Chat
          </button>
        </div>
        <div style={{ flex: 1, overflowY: "auto" }}>
          <AdminDashboard />
        </div>
      </div>
    );
  }

  if (view === "admin" && canManageUsers) {
    return (
      <>
        {isSuperadmin && (
          <div style={{ padding: "8px", background: "#2c3e50", display: "flex", gap: "8px", justifyContent: "center" }}>
            <button
              onClick={() => setView("dashboard")}
              style={{
                padding: "8px 16px",
                background: "#95a5a6",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              📈 Dashboard
            </button>
            <button
              onClick={() => setView("admin")}
              style={{
                padding: "8px 16px",
                background: "#3498db",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              👥 User Management
            </button>
            <button
              onClick={() => setView("chat")}
              style={{
                padding: "8px 16px",
                background: "#95a5a6",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              💬 Chat
            </button>
          </div>
        )}
        <AdminUsersPage onOpenChat={() => setView("chat")} />
      </>
    );
  }

  return (
    <ChatWindow
      onOpenAdmin={canManageUsers ? () => setView(isSuperadmin ? "dashboard" : "admin") : undefined}
    />
  );
}

function Root() {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="flex h-screen items-center justify-center text-sm text-slate-600">Loading…</div>;
  }
  if (!user) return <AuthPage />;
  return <AuthorizedApp />;
}

export default function App() {
  return (
    <AuthProvider>
      <Root />
    </AuthProvider>
  );
}